<!-- The <ng-content> is defined as a template because Angular does not like multiple <ng-content> elements
     targetting the same projection ('' in this case).

     When defined inside a named <ng-template>, the template is effectively instantiated once, before the ngSwitch is evaluated.
     Once the switch is evaluated, the contents are appended to the right case (and moved on change). -->

<ng-container [ngSwitch]="layout">
  <app-layout-noframe *ngSwitchCase="'noframe'">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </app-layout-noframe>
  <app-layout-default-shell
    *ngSwitchDefault
    [layoutParams]="params"
    [user]="user$ | async"

    (logout)="logout.emit()"

    [insightsLibraryVisible]="insightsLibraryVisible$ | async"
    (openInsightsLibrary)="openInsightsLibrary()">
    <ng-container *ngTemplateOutlet="template"></ng-container>
  </app-layout-default-shell>
</ng-container>

<ng-template #template>
  <ng-content #whenLoaded></ng-content>
</ng-template>
